import script from "./CreateProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateProduct.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__